module.exports = __webpack_public_path__ + "static/media/TEMPLATE_1.63f38389.webp";